import { ServiceAdministrationRoutingModule } from './service-administration-routing.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewServiceAdministrationComponent } from './view-service-administration/view-service-administration.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material/material.module';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { CommonComponentsModule } from '../common-components/common-components.module';
import { SearchServiceAdministrationComponent } from './search-service-administration/search-service-administration.component';
import { EditServiceAdministrationComponent } from './edit-service-administration/edit-service-administration.component';
import { DeleteServiceAdministrationCheckComponent } from './delete-service-administration-check/delete-service-administration-check.component';

@NgModule({
    declarations: [
        ViewServiceAdministrationComponent,
        SearchServiceAdministrationComponent,
        EditServiceAdministrationComponent,
        DeleteServiceAdministrationCheckComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        ReactiveFormsModule,
        FormsModule,
        PipesModule,
        CommonComponentsModule,
        ServiceAdministrationRoutingModule
    ]
})
export class ServiceAdministrationModule {}
